import { render, staticRenderFns } from "./App.vue?vue&type=template&id=2ebae6d9&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=2ebae6d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebae6d9",
  null
  
)

export default component.exports